'use strict';

const { pubdb } = Function('return this')();
const {
    window, document, $,
    display_list, map, echo, relogin, get_csrf_token, echo_errors, ajax_post, confirm, next_tick, path_root, trim,
    ajax_get, mustache, debounce, iframe_dialog, ajax_success_handler, encode_uri_component,
} = pubdb;
const {
    JSON, getSelection, setTimeout,
} = window;
const { parse } = JSON;


function req_error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
}


function format_abstract (text) {
    return mustache.render('{{> ESC_MOST_HTML|text|1}}', {text});
}


function editable_keywords (fp_id) {
    const fpkeywords = $('#fpkeywords');
    fpkeywords.on('click', '.assoc', function (ev) {
        ev.preventDefault();

        const btn = $(ev.currentTarget);
        if (btn.is('.add')) {
            do_add(btn);
        } else if (btn.is('.remove')) {
            do_remove(btn);
        }
    });

    function do_remove (btn) {
        let kw_id = btn.data('id');
        if (typeof(kw_id) === 'string') {
            kw_id = parse(kw_id);
        }
        if (!kw_id) {
            btn.closest('div').remove();
            return;
        }

        const text = btn.prev().text();
        confirm(
            'Zuordnung entfernen',
            'Wollen Sie die Zuordung zum Schlagwort „' + text + '“ wirklich entfernen?',
            [
                ['abbrechen'],
                ['entfernen', remove],
            ],
        );

        function remove () {
            ajax_post(
                path_root + '/fpkeyword/association/',
                {
                    csrf_token: pubdb.csrf_token,
                    kw: kw_id,
                    fp: fp_id,
                    action: 'del'
                },
                del_success,
                req_error,
            );
        }

        function del_success ({ success, reason, errors, toggled }) {
            if (!success) {
                if (reason === 'missing') {
                    if ('kw' in errors) {
                        echo('warn', 'Das Schlagwort wurde zwischenzeitlich gelöscht.');
                    }
                    if ('fp' in errors) {
                        echo('warn', 'Das Forschungsprojekt wurde zwischenzeitlich gelöscht.');
                    }
                } else if (reason === 'previleges') {
                    echo('warn', 'Sie dürfen diesen Forschungsprojekt nicht bearbeiten.');
                } else if (reason === 'exception') {
                    echo('warn', 'Beim Speichern trat ein Datenbankfehler auf.');
                } else if ('login_required' in errors) {
                    relogin();
                } else if ('csrf_token' in errors) {
                    get_csrf_token();
                } else if (reason === 'errors') {
                    echo_errors(errors);
                }
                return;
            }

            if (!toggled) {
                echo('confirm', 'Die Zuordnung zum Schlagwort war bereits entfernt.');
            } else {
                echo('confirm', 'Die Zuordnung zum Schlagwort wurde entfernt.');
            }
            btn.closest('div').remove();
        }
    }

    const NEW_DFKT_TEXT = 'Schlagwort suchen';

    function add_success ({ success, reason, errors, toggled }) {
        if (!success) {
            if (reason === 'missing') {
                if ('kw' in errors) {
                    echo('warn', 'Das Schlagwort wurde zwischenzeitlich gelöscht.');
                }
                if ('fp' in errors) {
                    echo('warn', 'Das Forschungsprojekt wurde zwischenzeitlich gelöscht.');
                }
            } else if (reason === 'previleges') {
                echo('warn', 'Sie dürfen diesen Forschungsprojekt nicht bearbeiten.');
            } else if (reason === 'exception') {
                echo('warn', 'Beim Speichern trat ein Datenbankfehler auf.');
            } else if ('login_required' in errors) {
                relogin();
            } else if ('csrf_token' in errors) {
                get_csrf_token();
            } else if (reason === 'errors') {
                echo_errors(errors);
            }
            return;
        }

        if (!toggled) {
            echo('confirm', 'Die Zuordnung zum Schlagwort war bereits vorhanden.');
        } else {
            echo('confirm', 'Die Zuordnung zum Schlagwort wurde hinzugefügt.');
        }

        return true;
    }

    function do_add (btn) {
        let edit_label_autocomplete;
        const edit_label_autocomplete_list = $('<ul/>', {
            style: 'margin: 0',
            append: $('<li>', { text: '…' }),
        });

        function do_post_add (id, en, description) {
            ajax_post(
                path_root + '/fpkeyword/association/',
                { csrf_token: pubdb.csrf_token, kw: id, fp: fp_id, action: 'add' },
                data => {
                    if (add_success(data)) {
                        replace_placeholder(id, en, description);
                    }
                },
                req_error,
            );
        }

        function remove_edit_label_autocomplete () {
            const old_edit_label_autocomplete = edit_label_autocomplete;
            if (old_edit_label_autocomplete) {
                next_tick(function () {
                    if (old_edit_label_autocomplete === edit_label_autocomplete) {
                        edit_label_autocomplete = null;
                        edit_label_autocomplete_list.detach();
                    }
                    old_edit_label_autocomplete.remove();
                });
            }
        }

        const query_list_cache = Object.create(null);
        function query_list () {
            let q = trim(edit_label.text() || '')
            if (q === NEW_DFKT_TEXT) {
                q = '';
            }

            const cached_result = query_list_cache[q];
            if (cached_result) {
                query_list_success(cached_result);
                return;
            }

            function query_list_success ({ success, total, data }) {
                if (!success) {
                    remove_edit_label_autocomplete();
                    return;
                }

                edit_label_autocomplete_list.empty();
                if (!data.length) {
                    $('<li>', {
                        style: 'display: inline-block',
                        append: [
                            $('<em>', { text: 'keine \xA0 ' }),
                            select_btn(0, '＋ neues Schlagwort').css('background-color', '#bfffcf'),
                        ],
                        appendTo: edit_label_autocomplete_list,
                    });
                    return;
                }

                function select_btn (id, en, description) {
                    const a = $('<a>', {
                        text: en,
                        attr: {
                            href: id ? `${path_root}/fpkeyword/${id}/` : 'javascript:;',
                            class: 'select-fkwp',
                        },
                        data: { id, en, description },
                    });

                    const div = $('<div>', {
                        style: 'display: inline-block',
                        append: $('<span>', {
                            append: a,
                        }),
                    });

                    if (description) {
                        div.attr('class', 'pubdb-tooltipped');
                        div.data('tooltip_rel', fpkw_wrapper);
                        $('<div>', {
                            style: 'display:none; max-width:400px;',
                            html: format_abstract(description),
                            appendTo: div,
                        });
                    }

                    $('<li>', {
                        style: 'display: inline-block; margin: 0;',
                        append: div,
                        appendTo: edit_label_autocomplete_list,
                    });

                    return a;
                }

                [].forEach.call(data, ({ id, en, description }) => { select_btn(id, en, description); });
                select_btn(0, '＋ neues Schlagwort').css('background-color', '#bfffcf');
            }

            ajax_get(
                path_root + '/fpkeyword/prefix/?q=' + encode_uri_component(q),
                function (data) {
                    query_list_cache[q] = data;
                    query_list_success(data);
                },
                function (data, err, xhr) {
                    debugger;  // ignored
                    remove_edit_label_autocomplete();
                },
            );
        }

        function add_edit_label_autocomplete () {
            next_tick(function () {
                if (edit_label_autocomplete) {
                    return;  // impossible?
                }

                query_list();

                edit_label_autocomplete = $('<div/>', {
                    style: 'display: inline-block',
                    append: $('<div/>', {
                        style: 'position: relative',
                        append: $('<div/>', {
                            style: 'position: absolute; z-index: 2; background-color: rgba(239, 239, 255, 0.925); border: 2px solid #06c; left: 2rem; top: 0.5rem; padding: 0.5ex 1ex; width: 30em;',
                            append: [
                                $('<strong>', { text: 'Vorschläge:' }),
                                $('<span>', { text: ' \xA0 Auswählen mit Klick.' }),
                                edit_label_autocomplete_list,
                            ],
                        }),
                    }),
                    insertBefore: fpkw_wrapper,
                });
            });
        }

        let ignore_focus = 0;
        const edit_label = $('<em>', {
            text: NEW_DFKT_TEXT,
            attr: {
                contenteditable: true,
                style: 'padding:0.1em;margin:0.1em;border:1px solid crimson;',
            },
            on: {
                focus (ev) {
                    next_tick(function () { --ignore_focus; });
                    if (ignore_focus++) {
                        return;
                    }

                    add_edit_label_autocomplete();

                    // https://stackoverflow.com/a/6150060/416224
                    const range = document.createRange();
                    range.selectNodeContents(this);
                    const sel = getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                },
                keydown (ev) {
                    const { key, which } = ev;
                    if (key !== 'Enter' && which !== 10 && which !== 13) {
                        return;
                    }
                    ev.preventDefault();

                    const text = trim(edit_label.text() || '');
                    if (!text) {
                        fpkw_wrapper.remove();
                        return;
                    }

                    ajax_get(
                        path_root + '/fpkeyword/by-en/?q=' + encode_uri_component(text),
                        function ({ id, en, description }) {
                            do_post_add(id, en, description);
                        },
                        function (data, err, xhr) {
                            new_fpkw(text);
                        },
                    );
                },
                input: debounce(query_list, 60),
                blur,
            },
        });

        function replace_placeholder (id, en, description) {
            edit_label.remove();
            kw_label.text(en);
            kw_label.attr('href', `${path_root}/fpkeyword/${id}/`);
            kw_delete.data('id', id);

            if (description) {
                $('<div>', {
                    html: format_abstract(description),
                    style: 'display:none;max-width:400px',
                    appendTo: fpkw_wrapper,
                });
                fpkw_wrapper.addClass('pubdb-tooltipped');
            }
        }

        function new_fpkw (en) {
            let iframe = iframe_dialog(
                path_root + '/fpkeyword/new/?content_only&callback=fp_saved',
                'Neues Schlagwort eintragen',
                onload,
                onunload
            );

            function onload (cW, ev) {
                cW.fp_saved = function ({ id, en, description }) {
                    iframe.dialog('close');
                    iframe = null;
                    do_post_add(id, en, description);
                };
                if (en) {
                    cW.$('[name=en]').val(en);
                }
            }

            function onunload (cW, ev) {
                next_tick(function () {
                    if (iframe) {
                        fpkw_wrapper.remove();
                        iframe.dialog('close');
                        iframe = null;
                    }
                });
            }
        }

        function blur (ev) {
            remove_edit_label_autocomplete();

            let { relatedTarget } = ev;
            if (!relatedTarget || !(relatedTarget = $(relatedTarget)).is('.select-fkwp')) {
                const { textContent } = this;
                if (!textContent || textContent === NEW_DFKT_TEXT) {
                    fpkw_wrapper.remove();
                }
                return;
            }

            const { id, en, description } = relatedTarget.data();
            if (!en) {
                return;  // impossible
            } else if (!id) {
                next_tick(function () {
                    const q = edit_label ? trim(edit_label.text() || '') : '';
                    new_fpkw(q);
                });
                return;
            }

            do_post_add(id, en, description);
        }

        const kw_label = $('<a>', {
            append: edit_label,
            href: 'javascript:;',
        });

        const kw_delete = $('<strong>', {
            text: '✘',
            data: {
                id: 0,
            },
            attr: {
                class: 'assoc remove',
                title: 'Zuordnung entfernen',
                style: 'color:crimson;cursor:pointer',
            },
        });

        const fpkw_wrapper = $('<div>', {
            style: 'display:inline-block',
            append: $('<span>', { append: [kw_label, kw_delete] }),
            insertBefore: btn.closest('div'),
        });

        next_tick(function () {
            edit_label.focus();
        });
    }
}


pubdb.display_fp_pubs = ({success, reason, data}, fp_id) => {
    if (fp_id) {
        editable_keywords(fp_id);
    }

    const dest = $('#pubdb_data')
    if (!data || !data.length) {
        dest.remove();
        return;
    }

    const will_be_action_extras = display_list(data, dest);
    fp_id && next_tick(function () {
        const [action_extras] = will_be_action_extras;
        if (!action_extras) {
            return;
        }

        action_extras.data_cb = function data_cb (pubs_list, selected_export, selected_scope) {
            if (!selected_export || selected_export[0] !== 'unlink') {
                return;
            }

            if (pubs_list.type === 'pubs') {
                var pub_ids = map(pubs_list, p => p.id);
            } else {
                var pub_ids = [].slice.call(pubs_list, 0);
            }

            function success (resp) {
                if (!ajax_success_handler(resp)) {
                    return;
                }

                const { data } = resp;
                const { missing, not_fp, unlinked } = data;
                if (missing && missing.length) {
                    echo('warn', missing +' Publikationen wurden zwischenzeitlich gelöscht.');
                }
                if (not_fp && not_fp.length) {
                    echo('confirm', not_fp +' Publikationen wurden bereits zuvor von dieser Seite entfernt.');
                }
                if (unlinked && unlinked.length) {
                    echo('confirm', unlinked +' Publikationen wurden von dieser Seite entfernt.');
                }
            }

            function remove () {
                ajax_post(
                    path_root + '/forschungsprojekt/' + fp_id + '/unlink/pubs/',
                    {
                        csrf_token: pubdb.csrf_token,
                        id: fp_id,
                        pub_ids,
                    },
                    success,
                    req_error,
                );
            }

            confirm(
                'Entfernen von Publikationen von einer Forschungsprojektliste',
                'Wollen Sie wirkliche die ' + pub_ids.length + ' Publikation(en) ' +
                'von der Liste dieses Forschungsprojektes entfernen? ' +
                'Die Publikationen können später wieder hinzugefügt werden.',
                [
                    ['abbrechen'],
                    ['von Liste entfernen', remove],
                ],
            );
        };

        $('<div/>', {
            append: [
                $('<h4/>').text('Spezielle Funktionen:'),
                $('<label/>', {
                    append:[
                        $('<input/>', {
                            type: 'radio',
                            value: 'unlink',
                            name: 'export-action'
                        }),
                        $('<span/>').text(' von FP-Liste entfernen')
                    ]
                })
            ],
            insertAfter: $('.PD_actions_action', dest),
        });
    });
};
